export default "__VITE_ASSET__WzVd72KU__"